import { FavoriteLibService } from '@aipb/personal-content/data-access';
import { NibbleDetailDialogService } from '@aipb/personal-content/dialog-nibble-detail';
import { NibbleCut } from '@aipb/personal-content/shared/model';
import { UseCase } from '@aipb/util/usecase';
import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetailUseCase implements UseCase<NibbleCut> {
  private favoriteLibService = inject(FavoriteLibService);
  private nibbleDetailDialogService = inject(NibbleDetailDialogService);

  execute(data: NibbleCut) {
    return this.nibbleDetailDialogService
      .open$({
        nibbleId: data.nibble.id
      })
      .pipe(
        tap(() => {
          this.favoriteLibService.refreshPlugin();
        })
      );
  }
}
